import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found-component',
  templateUrl: './page-not-found-component.component.html',
  styleUrls: ['./page-not-found-component.component.less']
})
export class PageNotFoundComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
